import { underwriterApi, underwritingReportApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const UW_REPORTS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/uwReports`,
  {
    GET_UW_REPORTS_BY_LOAN_ID: 'GET_UW_REPORTS_BY_LOAN_ID',
    GET_UW_REPORT_BY_REPORT_ID: 'GET_UW_REPORT_BY_REPORT_ID',
    GENERATE_NEW_UW_REPORT: 'GENERATE_NEW_UW_REPORT',
  },
);

const reports = new schema.Entity('reports', {}, { idAttribute: 'reportId' });

export const getUwReportsByLoanIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingReportApi.getUnderwritingReportLoanByLoanId(params);

  return dispatch({
    type: UW_REPORTS_ACTION_TYPE.GET_UW_REPORTS_BY_LOAN_ID,
    payload: normalize(data, [reports]).entities.reports,
  });
});

export const getUwReportByReportIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingReportApi.getUnderwritingReportByReportId(params);

  return dispatch({
    type: UW_REPORTS_ACTION_TYPE.GET_UW_REPORT_BY_REPORT_ID,
    payload: data,
  });
});

export const generateNewUwReport = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwriterApi.createUnderwriterVerify(params);

  return dispatch({
    type: UW_REPORTS_ACTION_TYPE.GENERATE_NEW_UW_REPORT,
    payload: data,
  });
});
